import * as AppConstants from 'app/AppConstants';
import {ROLE_IDS} from 'app/Roles';
import {STATUSES} from './environmentConstants';

const initialState = () => ({
  status: STATUSES.INITIAL,
  user: {},
  authorizedDomains: [],
  authorizedAppDomains: [],
  authorities: [],
  isDashboardTypeConfigured: false,
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.ENVIRONMENT__LOAD_ENVIRONMENT_STARTED:
      return {
        ...state,
        status: STATUSES.LOADING,
      };

    case AppConstants.ENVIRONMENT__LOAD_ENVIRONMENT_FINISHED:
      return {
        ...state,
        status: STATUSES.LOADED,
        ...action.payload,
        user: {
          ...state.user,
          ...action.payload.user,
        },
      };

    case AppConstants.ENVIRONMENT__LOAD_ENVIRONMENT_FAILED:
      return {
        ...state,
        status: STATUSES.ERROR,
      };

    case AppConstants.ENVIRONMENT__TRIAL_STATUS_LOADED: {
      return {
        ...state,
        user: {
          ...state.user,
          trialStatus: action.payload,
        },
      };
    }

    case AppConstants.ENVIRONMENT__BEGAN_TRIAL_STARTED: {
      return {
        ...state,
        user: {
          ...state.user,
          roleId: ROLE_IDS.EDITOR,
          trialStatus: {
            roleId: ROLE_IDS.EDITOR,
          },
        },
      };
    }

    case AppConstants.ENVIRONMENT__BEGAN_TRIAL_FAILED: {
      return {
        ...state,
        user: {
          ...state.user,
          roleId: ROLE_IDS.SOCIAL,
          trialStatus: {
            role: ROLE_IDS.SOCIAL,
          },
        },
      };
    }

    case AppConstants.ENVIRONMENT__BEGAN_TRIAL_FINISHED: {
      return {
        ...state,
        user: {
          ...state.user,
          roleId: ROLE_IDS.EDITOR,
          trialStatus: {
            roleId: ROLE_IDS.EDITOR,
            started: Date.now(),
            inTrial: true,
            hasTrialed: true,
          },
        },
      };
    }

    case AppConstants.ENVIRONMENT__REQUEST_UPGRADE_STARTED: {
      return {
        ...state,
        user: {
          ...state.user,
          trialStatus: {
            ...state.user.trialStatus,
            requested: true,
          },
        },
      };
    }

    case AppConstants.ENVIRONMENT__REQUEST_UPGRADE_FAILED: {
      return {
        ...state,
        user: {
          ...state.user,
          trialStatus: {
            ...state.user.trialStatus,
            requested: false,
          },
        },
      };
    }

    case AppConstants.ENVIRONMENT__REQUEST_UPGRADE_FINISHED: {
      return {
        ...state,
        user: {
          ...state.user,
          trialStatus: {
            ...state.user.trialStatus,
            requested: true,
          },
        },
      };
    }

    default: {
      return state;
    }
  }
};
